import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import SettingsIcon from '@mui/icons-material/Settings';

import PageTitle from '@/shared/components/layouts/PageTitle';
import routeIcon from '@/shared/configs/routeIcon';
import { AppPath } from '@/shared/constants/path';
import NavigationItem from '@/shared/types/navigationItem.type';

type TitleProps = {
  activeNavigationItem: NavigationItem | null;
};

const Title: FC<TitleProps> = ({ activeNavigationItem }) => {
  const { t } = useTranslation(['common']);

  return (
    <PageTitle
      title={t('common:settings')}
      breadcrumbs={[
        {
          label: t('common:settings'),
          to: AppPath.Settings,
          icon: (
            <SettingsIcon
              sx={{ width: 16, height: 16, color: 'text.secondary' }}
            />
          ),
        },
        {
          label: t(activeNavigationItem?.label ?? ''),
          to: activeNavigationItem?.href,
          icon: activeNavigationItem
            ? routeIcon[activeNavigationItem.href]?.renderIcon({
                width: 16,
                height: 16,
              })
            : null,
        },
      ]}
    />
  );
};

export default Title;
